import React from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import '../styles/earn.scss';
import ModalComponent from './Modal';

function Earn() {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    ReactGA.pageview('OPEN -> SignUpModal');
    ReactPixel.trackCustom('CLOSE -> SignUpModal');
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  return (
    <div className="Earn">
      <div className="container container-earn">
        <p className="titleEarn">
          <b>Earn</b> by questing
        </p>
        <p className="textEarn">
          Join uQuest→ Search for Quests→ Compete with other Players→ Complete
          the Quest→ Receive your Payment→ Review the Giver → You and your whole
          Tribe get paid
        </p>
        <button onClick={() => openModal()} className="earn-btn">
          Get Early Access
        </button>
      </div>
      <ModalComponent closeModal={() => closeModal()} isOpen={modalIsOpen} />
    </div>
  );
}

export default Earn;
